<app-si-dialog modalBodyClasses="flex flex-col h-full w-full overflow-hidden p-4 min-h-[200px]" header="Export Contacts to Salesforce">
	<ng-template appDialogBody>
		<ng-container *ngIf="accuracyTier">
			<div class="mb-4 text-center rounded-md border border-warning bg-warning-container text-dark px-4 py-3 text-sm">{{accuracyTierText}}</div>
		</ng-container>

		<div class="flex flex-col overflow-hidden">
			<div *ngIf="isBusy; else notBusyTpl" class="my-12">
				<div class="flex flex-wrap -mx-2">
					<div class="w-full sm:flex-none sm:w-1/12 px-2">
					</div>
					<div class="w-full sm:flex-none sm:w-5/6 text-center px-2">
						<b>{{busyLabel}}</b><br />
						{{busySublabel}}
					</div>
					<div class="w-full sm:flex-none sm:w-1/12 px-2">
					</div>
				</div>
			</div>

			<ng-template #notBusyTpl>
				<ng-container [ngSwitch]="pages[currentPageIndex]?.type">
					<ng-container *ngSwitchCase="pageTypes.LOADING">
						<div class="pt-6" *ngIf="!isExportButton">
							<section>
								<div class="flex justify-center pt-6">
									<mat-spinner></mat-spinner>
								</div>
							</section>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.EXPORT_TYPE">
						<ng-container *ngIf="!isExportButton">
							<h3>Export Type</h3>
							Select how you want to export the selected contacts.
							<br /><br />
							<div class="table-scroll">
								<table class="si-table si-table--striped si-table--hover si-table--grid">
									<thead>
									<tr>
										<th class="flex-none w-full px-2">
											Export Type
										</th>
									</tr>
									</thead>
									<tbody>
									<tr>
										<td class="pt-2 pb-2" (click)="setExportType('lead')">
											Export as Lead
										</td>
									</tr>
									<tr>
										<td class="pt-2 pb-2" (click)="setExportType('contact')">
											Export as Contact
										</td>
									</tr>
									</tbody>
								</table>
							</div>
						</ng-container>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.LEAD_OWNER">
						<h3>{{ exportType | titlecase }} Owner (optional)</h3>
						Select a {{ exportType }} owner for the selected contacts. This is optional.
						<br /><br />
						<div class="flex-none w-full pl-0 pr-0">
							<mat-form-field appearance="outline" class="mb-1 w-full no-padding">
								<mat-label>Filter by name or email</mat-label>
								<input matInput type="text" placeholder="Filter by name or email" [(ngModel)]="filterLeadOwner">
								<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
							</mat-form-field>
						</div>

						<div class="table-scroll">
							<table class="table-fixed si-table si-table--striped si-table--hover si-table--grid">
								<thead>
								<tr>
									<th class="flex-none w-1/2 px-2">
										Name
									</th>
									<th class="flex-none w-5/12 px-2">
										Email
									</th>
									<th *ngIf="(leadOwners | filter: filterLeadOwner).length > 0" class="flex-none w-1/12 px-2">
										&nbsp;
									</th>
								</tr>
								</thead>
								<tbody>
								<tr (click)="selectLeadOwner(leadowner.id)"
									*ngFor="let leadowner of leadOwners | filter: filterLeadOwner | orderBy : 'name'">

									<td class="flex-none w-1/2 px-2">{{ leadowner.name }}</td>
									<td class="flex-none w-5/12 px-2">{{ leadowner.email }}</td>
									<td class="flex-none w-1/12 text-center px-0">
										<fa-icon [hidden]="leadowner.id !== selectedLeadOwner" class="py-0" [icon]="['fas', 'check']"></fa-icon>
									</td>

								</tr>
								<tr *ngIf="(leadOwners | filter: filterLeadOwner).length === 0">
									<td colspan="2" class="flex-none w-full text-center bg-white py-6 px-2">
										<i>No {{ exportType | titlecase }} Owners Found</i>
									</td>
								</tr>
								</tbody>
							</table>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.ACCOUNT_MAPPING">
						<div *ngIf="!isLoadingAccountMapping">
							<h3>
								Assign contacts to account
							</h3>
							<p *ngIf="generalSettings.sfCreateNewAccounts==false" class="text-danger">Salesforce admin has disabled create new account.</p>
							<div class="flex flex-wrap -mx-2">
								<div class="w-full md:flex-none md:w-2/3 px-2">
									<mat-form-field appearance="outline" class="mb-1 w-full no-padding">
										<mat-label>Filter</mat-label>
										<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
										<input matInput type="text" placeholder="Filter by contact name, company name, title" [(ngModel)]="filterAccountMapping" (keyup)="onChangeAccountFilter()">
										<button *ngIf="filterAccountMapping" matSuffix matIconButton class="mat-primary" type="button" aria-label="Close" (click)="filterAccountMapping='';onChangeAccountFilter()">
											<fa-icon matPrefix class="si-icon" [icon]="['fal', 'xmark']"></fa-icon>
										</button>
									</mat-form-field>
								</div>
								<div class="w-full md:flex-none md:w-1/3 px-2">
									<button matButton="filled" type="button" [disabled]="getSelectdContact().length==0" class="float-right" (click)="onSelectAccount(null)">Map selected accounts ({{getSelectdContact().length}})</button>
								</div>
							</div>

							<div class="table-scroll">
								<table class="relative si-table">
									<thead>
									<tr>
										<th class="align-middle bg-white border-t-0 sticky top-0">
											<mat-checkbox
													title="Select All"
													[(ngModel)]="isSelectedAll"
													(change)="toggleSelectAll()"
											></mat-checkbox>
										</th>
										<th class="w-1/4 bg-white border-t-0 sticky top-0">Contact Name</th>
										<th class="width-20 bg-white border-t-0 sticky top-0">Company Name</th>
										<th class="width-25 bg-white border-t-0 sticky top-0">Account Name</th>
										<th class="width-15 bg-white border-t-0 sticky top-0">Account Owner</th>
										<th class="width-15 bg-white border-t-0 text-center sticky top-0">Create Account</th>
									</tr>
									</thead>
									<tbody>
									<tr *ngFor="let contact of contacts | salesForceAccountMappingFilter: filterAccountMapping | orderBy : 'name'">
										<ng-container *ngIf="contact.matchId">
											<td class="align-middle">
												<mat-checkbox
														title="Select"
														[(ngModel)]="contact.selectedContact"
														(change)="checkIfAllSelected()"
														(click)="$event.stopPropagation()"
												></mat-checkbox>
											</td>
											<td>
												<div>{{contact.name}}</div>
												<div>{{contact.jobTitle}}</div>
											</td>
											<td>{{contact.companyName}}</td>
											<td>
												<div>
													<ng-container *ngIf="contact.accountId">
														<span>{{contact.accountName}}</span>
														<button type="button" aria-label="Close" (click)="clearAccount(contact.matchId)" class="close float-none ml-2 align-middle account-close-cls">
															<span aria-hidden="true">×</span>
														</button>
													</ng-container>
													<ng-container *ngIf="!contact.accountId">
														<button
															matButton="text"
															[disabled]="contact.selectedContact"
															(click)="onSelectAccount(contact)"
															type="button"
															class="si-link-button italic underline select-account-btn"
														>Select an account</button>
														<div *ngIf="contact.accountTotal >1">
															<small class="italic text-danger">We found {{contact.accountTotal}} accounts. Please select one.</small>
														</div>
													</ng-container>
												</div>
											</td>
											<td>
												<span>{{contact.ownerName}}</span>
											</td>
											<td class="text-center">
												<mat-checkbox
														title="Create Company"
														[(ngModel)]="contact.createCompany"
														[disabled]="!generalSettings.sfCreateNewAccounts"
														(click)="$event.preventDefault();"
												></mat-checkbox>
											</td>
										</ng-container>
									</tr>
									<tr *ngIf="(contacts | salesForceAccountMappingFilter: filterAccountMapping).length === 0">
										<td colspan="6" class="flex-none w-full text-center bg-white py-6 px-2">
											<i>No Contacts Found</i>
										</td>
									</tr>
									</tbody>
								</table>

							</div>
						</div>

						<div class="pt-6" *ngIf="isLoadingAccountMapping">
							<section>
								<div class="flex justify-center pt-6">
									<mat-spinner></mat-spinner>
								</div>
							</section>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.CAMPAIGN">
						<h3>Campaigns (optional)</h3>
						Select one or more campaigns you want to assign the selected contacts to. This is optional.
						<br /><br />
						<div class="flex-none w-full pl-0 pr-0">
							<mat-form-field appearance="outline" class="mb-1 w-full no-padding">
								<mat-label>Filter by name</mat-label>
								<input matInput type="text" placeholder="Filter by name" [(ngModel)]="filterCampaigns">
								<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
							</mat-form-field>
						</div>
						<div class="table-scroll">
							<table class="table-fixed si-table si-table--striped si-table--hover si-table--grid">
								<thead>
								<tr>
									<th class="w-full sm:flex-none sm:w-5/6 px-2">
										Name
									</th>
									<th class="w-full sm:flex-none sm:w-1/6 px-2">
										&nbsp;
									</th>
								</tr>
								</thead>
								<tbody>
								<tr (click)="selectCampaign(campaign.id)"
									*ngFor="let campaign of campaigns | filter : filterCampaigns | orderBy : 'name'">
									<td class="w-full sm:flex-none sm:w-5/6 px-2">{{ campaign.name }}</td>
									<td class="w-full sm:flex-none sm:w-1/6 text-center px-0">
										<fa-icon [hidden]="!selectedCampaignIds.includes(campaign.id)" class="py-0" [icon]="['fas', 'check']"></fa-icon>
									</td>
								</tr>
								<tr *ngIf="(campaigns | filter: filterCampaigns).length === 0">
									<td colspan="2" class="w-full sm:flex-none sm:w-full text-center bg-white py-6 px-2"><i>No Campaigns Found</i></td>
								</tr>
								</tbody>
							</table>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.DUPLICATES">
						<h3>Duplicates</h3>
						<div class="flex flex-wrap -mx-2">
							<div class="flex-none w-1/2 px-2">
								<b>Found {{ duplicateCount }} duplicate<span *ngIf="duplicateCount != 1">s</span>:</b>
							</div>
							<div class="flex-none w-1/2 label-group px-2">
								<b>Resolve Duplicates by:</b>
							</div>
						</div>
						<div class="flex flex-wrap -mx-2 mt-2">
							<div class="flex-none w-1/2 table-scroll px-2">
								<table class="table-fixed si-table si-table--hover si-table--grid">
									<tbody>
									<tr *ngFor="let match of duplicateMatchIds ">
										<td class="flex-none w-full px-2">{{ match.contact_name }}
										</td>
									</tr>
									</tbody>
								</table>
							</div>
							<div class="flex-none w-1/2 px-2">
								<app-duplicate-resolution-radio-group [(ngModel)]="duplicateResolution"></app-duplicate-resolution-radio-group>
							</div>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.DUPLICATES_ASYNC">
						<div class="flex flex-wrap -mx-2 gap-0 py-6">
							<div class="flex-none w-full px-2">
								<h3>Duplicates</h3>
								<p>Resolve Duplicates by:</p>
								<app-duplicate-resolution-radio-group [(ngModel)]="duplicateResolution"></app-duplicate-resolution-radio-group>
							</div>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.JOB_TITLE">
						<div class="flex flex-wrap -mx-2 gap-0 py-12">
							<div class="flex-none w-full px-2">
								<mat-form-field appearance="outline" class="mb-1 w-full">
									<mat-label>Job Name (optional)</mat-label>
									<input matInput type="text" [formControl]="jobTitleControl" placeholder="Job Name">
								</mat-form-field>
							</div>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.EXPORT">
						<ng-container *ngIf="isLoading$ | async; else finishedAsyncTpl">
							<div class="flex justify-center pt-6">
								<mat-spinner></mat-spinner>
							</div>
						</ng-container>
						<ng-template #finishedAsyncTpl>
							<div class="py-12">
								<p class="mb-0 text-center">Due to the size of your request, you will receive an email when your export is ready. This may take 30 minutes or more during busy times.</p>
							</div>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.EXPORT_FINISHED">
						<div class="mt-1 pl-4">
							<div class="flex flex-wrap -mx-2">
                                <ng-container *ngIf="exportedContactCount > 0 && failedContacts.length !== exportedContactCount; else contactFailedHeader">
                                    <h3 class="flex-none w-full px-2">Export Succeeded</h3>
                                </ng-container>
                                <ng-template #contactFailedHeader>
                                    <h3 class="flex-none w-full px-2">Export Failed</h3>
                                </ng-template>

								<div class="flex-none w-full pl-4 pb-2"
									 *ngIf="(failedContacts.length === 0 && exportedContactCount > 0) && (duplicateResolution === 'skip' || (exportType === 'contact' && duplicateLeadsCount === 0) || (exportType === 'lead' && duplicateContactsCount === 0))">
									You have successfully exported {{exportedContactCount}}
									<span *ngIf="exportedContactCount === 1">contact as a {{ exportType }}</span>
									<span *ngIf="exportedContactCount !== 1">contacts as {{ exportType }}s</span> to
									Salesforce.
								</div>

								<div class="flex-none w-full pl-4 pb-2"
									 *ngIf="exportType === 'contact' && duplicateLeadsCount > 0 && duplicateResolution !== 'skip'">
									<div *ngIf="exportedContactCount > duplicateLeadsCount && failedContacts.length === 0">
										You have successfully exported {{(exportedContactCount - duplicateLeadsCount)}}
										<span *ngIf="(exportedContactCount - duplicateLeadsCount) === 1">contact as a
											{{ exportType }}</span>
										<span *ngIf="(exportedContactCount - duplicateLeadsCount) != 1">contacts as
											{{ exportType }}s</span> to Salesforce.
									</div>
								</div>

								<div class="flex-none w-full pl-4 pb-2"
									 *ngIf="exportType === 'lead' && duplicateContactsCount > 0 && duplicateResolution !== 'skip'">
									<div *ngIf="exportedContactCount > duplicateContactsCount && failedContacts.length === 0">
										You have successfully exported {{(exportedContactCount - duplicateContactsCount)}}
										<ng-container *ngIf="(exportedContactCount - duplicateContactsCount) === 1"> contact as a
											{{ exportType }}</ng-container>
										<ng-container *ngIf="(exportedContactCount - duplicateContactsCount) != 1"> contacts as
											{{ exportType }}s</ng-container> to Salesforce.
									</div>
								</div>

                                        <div class="flex-none w-full px-2" *ngIf="failedContacts.length > 0">
                                            <p>You have successfully exported {{ exportedContactCount - failedContacts.length}}
													out of {{exportedContactCount}}
													<ng-container *ngIf="exportedContactCount === 1">contact as a {{ exportType }}</ng-container>
													<ng-container *ngIf="exportedContactCount !== 1">contacts as {{ exportType }}s</ng-container> to Salesforce.</p>

                                            <table class="table-fixed si-table si-table--hover">
                                                <tr *ngFor="let failedContact of failedContacts">
                                                    <td class="flex-none w-full text-danger px-2">
                                                        Failed export <strong>{{failedContact.contactName}}</strong> at
																{{failedContact.companyName}}: {{failedContact.errorMessage}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                        <div class="flex-none w-full px-2" *ngIf="failedAccounts.length > 0">
                                            <p>For <ng-container *ngIf="generalSettings.sfOrphanRecords">{{failedContacts.length}} contact<ng-container *ngIf="failedContacts.length > 1">s </ng-container></ng-container>
													<ng-container *ngIf="!generalSettings.sfOrphanRecords">
														{{contactFailureCounts ? contactFailureCounts : 0}} contact
														<ng-container *ngIf="contactFailureCounts > 1">s </ng-container>
													</ng-container> the connected account couldn't be updated. This could be caused by the
													Salesforce DuplicateChecker or because SalesIntel is not allowed to create new
													Accounts in your Salesforce instance.</p>

                                            <table class="table-fixed si-table si-table--hover">
                                                <tr *ngFor="let failedAccount of failedAccounts">
                                                    <td class="flex-none w-full text-danger px-2">
                                                        Failed export at {{failedAccount.companyName}}:
																{{failedAccount.errorMessage}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                        <div class="flex-none w-full px-2" *ngIf="exportType === 'contact' && duplicateLeadsCount > 0 && duplicateResolution !== 'skip'">
                                            <p>For {{duplicateLeadsCount}} contact<ng-container *ngIf="duplicateLeadsCount != 1">s</ng-container>
													we found a duplicate lead in Salesforce. We updated
													<ng-container *ngIf="duplicateLeadsCount === 1">that lead</ng-container>
													<ng-container *ngIf="duplicateLeadsCount !== 1">those leads</ng-container> as we
													cannot automatically convert leads into contacts. Please login to the Salesforce
													portal to manually convert below lead
													<ng-container *ngIf="duplicateLeadsCount != 1">s</ng-container> into contacts.</p>

                                            <table class="table-fixed si-table si-table--hover">
                                                <tr *ngFor="let lead of duplicateLeadsMatchIds">
                                                    <td class="flex-none w-full text-danger px-2">
                                                        <b>{{lead.contact_name}}</b> at
																{{lead.company_name}} found as Lead
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                        <div class="flex-none w-full px-2" *ngIf="exportType === 'lead' && duplicateContactsCount > 0 && duplicateResolution !== 'skip'">
                                            <p>For below {{duplicateContactsCount}} contact
													<ng-container *ngIf="duplicateContactsCount != 1">s</ng-container>
													we found an existing contact in Salesforce.
													We updated <ng-container *ngIf="duplicateContactsCount === 1">that contact</ng-container>
													<ng-container *ngIf="duplicateContactsCount !== 1">those contacts</ng-container> as we cannot
													convert contacts back into leads.</p>

                                            <table class="table-fixed si-table si-table--hover">
                                                <tr *ngFor="let contact of duplicateContactsMatchIds">
                                                    <td class="flex-none w-full text-danger px-2">
                                                        <b>{{contact.contact_name}}</b> at {{contact.company_name}} found as
																Contact
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

								</div>

								<div class="flex-none w-full px-2">
							<span *ngIf="duplicateFailedContacts.length > 0">However {{duplicateFailedContacts.length}}
								contact<span *ngIf="duplicateFailedContacts.length != 1">s</span>
								couldn't be exported, most likely because the Salesforce DuplicateChecker detected it as a
								duplicate. We suggest you import the failed contacts manually into Salesforce.
							</span>
								</div>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.EXPORT_EMPTY">
						<div class="text-center">
							<h3>Nothing to Export</h3>
							All selected contacts are duplicates and you decided to skip duplicates, so there's nothing left to export.
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.EXPORT_FAILED">
						<div>
							<h3>Export Failed</h3>
							Your export failed with the following error: <br /><br />
							<pre class="text-danger" style="max-height: 200px; white-space: pre-wrap;">{{exportError}}</pre><br />
							Please resolve the problem in your Salesforce instance and retry or contact SalesIntel support at <a
								href="mailto:support@salesintel.io">support&#64;salesintel.io</a>.
						</div>
					</ng-container>
				</ng-container>

				<div *ngIf="isExportButton">
					<table class="si-table">
						<thead>
						<tr class="border-bottom-primary">
							<th><span class="pl-6 ml-2">Type of Contact</span></th>
							<th class="numeric">Count</th>
							<th class="numeric">Action</th>
						</tr>
						</thead>
						<tbody>
						<tr *ngIf="humanverified.length > 0">
							<td><span class="export-icon human-verified"
									  [matTooltip]="(humanverified.length == 1 ? 'This contact has' : 'These contacts has') + ' been Human Verified by SalesIntel and can be exported with its enriched details.'"
									  matTooltipPosition="after"></span> Human Verified</td>
							<td class="numeric">{{humanverified.length}}</td>
							<td>Export to Salesforce</td>
						</tr>
						<tr *ngIf="machineverified.length > 0 || unmatchedContacts.length > 0">
							<td><fa-icon [matTooltip]="((machineverified.length + unmatchedContacts.length) == 1 ? 'This contact has' : 'These contacts has') + ' been Machine Verified by SalesIntel. You may get it verified by a human using our Research on Demand service.'" matTooltipPosition="after" class="mr-2" [icon]="['fas', 'desktop']"></fa-icon>&nbsp;&nbsp;&nbsp;Machine Verified</td>
							<td class="numeric">{{machineverified.length + unmatchedContacts.length}}</td>
							<td>
								<ng-container *ngIf="commonUtilService.hasRODCreditsRemaining">Submit to Research on Demand<fa-icon matTooltip="These records will be sent to our team of researchers to validate the information. If Auto-Export is enabled in your settings, these contacts will be automatically exported to Salesforce after validation." matTooltipPosition="after" class="ml-2" [icon]="['fas', 'circle-info']"></fa-icon></ng-container>
								<span class="rod-text" *ngIf="!commonUtilService.hasRODCreditsRemaining">
									Research on Demand for Machine Verified records is not enabled for you.<br /> Please contact
									us to upgrade your plan and enable these features.
								</span>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</ng-template>
		</div>
	</ng-template>

	<ng-template appDialogFooter>
		<div>
			<button matButton="outlined" type="button" *ngIf="showCancelButton && !isBusy" (click)="onClose()">Cancel</button>
		</div>

		<div>
			<div *ngIf="isExportButton && !isBusy">
				<button matButton="outlined" type="button" class="ml-4" (click)="exportInboxintel()">
					Export</button>
			</div>
			<button matButton="outlined" type="button" class="mr-2" *ngIf="showPreviousButton && !isBusy"
					(click)="previous()">Previous</button>
			<button matButton="filled" type="button" *ngIf="showNextButton && !isBusy" [disabled]="isNextDisabled()" (click)="next()">
				<ng-container *ngIf="pages[currentPageIndex]?.type === pageTypes.JOB_TITLE; else nextTpl">Export</ng-container>

				<ng-template #nextTpl>Next</ng-template>
			</button>
			<button matButton="filled" type="button" *ngIf="showRetryButton" (click)="retryExport()">Retry</button>
			<button matButton="outlined" type="button" *ngIf="showCloseButton"
					(click)="onClose()">Close</button>
		</div>
	</ng-template>
</app-si-dialog>
